import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2afe475e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home-container"
}
const _hoisted_2 = { class: "app__header__title" }
const _hoisted_3 = { class: "app__title" }
const _hoisted_4 = { class: "hotel-card__title" }
const _hoisted_5 = {
  key: 0,
  class: "gray__base__color hotel-card__address"
}
const _hoisted_6 = { class: "carousel__container" }
const _hoisted_7 = { class: "box-card" }
const _hoisted_8 = {
  id: "roomDetails",
  style: {"width":"100%"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons room__icon" }, "hotel")
], -1))
const _hoisted_10 = { class: "room__text" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons room__icon" }, "people")
], -1))
const _hoisted_12 = { class: "room__text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons room__icon" }, "face")
], -1))
const _hoisted_14 = { class: "room__text" }
const _hoisted_15 = { class: "hotel-list__container" }
const _hoisted_16 = { class: "hotel-list__height" }
const _hoisted_17 = { class: "hotel__title" }
const _hoisted_18 = {
  key: 0,
  class: "hotel__address"
}
const _hoisted_19 = { class: "box-card" }
const _hoisted_20 = {
  id: "roomDetails",
  style: {"width":"100%"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons room__icon" }, "hotel")
], -1))
const _hoisted_22 = { class: "room__text" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons room__icon" }, "people")
], -1))
const _hoisted_24 = { class: "room__text" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons room__icon" }, "face")
], -1))
const _hoisted_26 = { class: "room__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_ctx.eventData && _ctx.eventData.hotels)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("hotels.hotelBooking")), 1),
                _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("hotels.hotelsAvailable")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { class: "hidden-xs-only mt-2" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventData.hotels, (hotel, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 8,
                xl: 8,
                class: "pa",
                key: hotel.id + index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, {
                    class: "hotel__card",
                    onClick: ($event: any) => (_ctx.goTo('HotelDetails', hotel.id))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        (_ctx.eventData.hotels && hotel.pictures)
                          ? (_openBlock(), _createBlock(_component_el_image, {
                              key: 0,
                              class: "hotel-card__image",
                              fit: "cover ",
                              src: hotel.pictures[0]
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("h3", _hoisted_4, _toDisplayString(hotel.name), 1),
                      _createVNode(_component_el_rate, {
                        class: "hotel-card__stars",
                        modelValue: hotel.starts,
                        "onUpdate:modelValue": ($event: any) => ((hotel.starts) = $event),
                        disabled: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      (hotel.description)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(hotel.description.substring(0, 75) + "..."), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_el_carousel, {
                          interval: 3000,
                          arrow: "never"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotel.rooms, (room, index) => {
                              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                key: room.id + index
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("p", {
                                      class: _normalizeClass('room__button' + (index + 1))
                                    }, [
                                      _createElementVNode("span", null, "$ " + _toDisplayString(room.amount), 1),
                                      _createTextVNode(" " + _toDisplayString(room.roomName), 1)
                                    ], 2),
                                    _createElementVNode("div", _hoisted_8, [
                                      _createVNode(_component_el_row, {
                                        guter: 24,
                                        class: "room__details"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, { span: 8 }, {
                                            default: _withCtx(() => [
                                              _hoisted_9,
                                              _createElementVNode("p", _hoisted_10, _toDisplayString(room.roomType), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_el_col, { span: 8 }, {
                                            default: _withCtx(() => [
                                              _hoisted_11,
                                              _createElementVNode("p", _hoisted_12, " x" + _toDisplayString(room.roomCapacityAdults), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_el_col, { span: 8 }, {
                                            default: _withCtx(() => [
                                              _hoisted_13,
                                              _createElementVNode("p", _hoisted_14, " x" + _toDisplayString(room.roomCapacitychildren), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          gutter: 20,
          class: "hidden-sm-and-up mt-2"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventData.hotels, (hotel, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                xs: 24,
                sm: 24,
                md: 24,
                lg: 24,
                xl: 24,
                key: hotel.id + index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, {
                    class: "hotel__card",
                    onClick: ($event: any) => (_ctx.goTo('HotelDetails', hotel.id))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          (_ctx.eventData.hotels && hotel.pictures)
                            ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 0,
                                class: "hotel-card__image",
                                fit: "cover ",
                                src: hotel.pictures[0]
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("h3", _hoisted_17, _toDisplayString(hotel.name), 1),
                      _createVNode(_component_el_rate, {
                        class: "hotel__stars",
                        modelValue: hotel.starts,
                        "onUpdate:modelValue": ($event: any) => ((hotel.starts) = $event),
                        disabled: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      (hotel.description)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(hotel.description.substring(0, 90) + "..."), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            xs: 24,
                            sm: 24,
                            md: 24,
                            lg: 24,
                            xl: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_carousel, {
                                interval: 3000,
                                arrow: "never"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotel.rooms, (room, index) => {
                                    return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                      key: room.id + index
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_19, [
                                          _createElementVNode("p", {
                                            class: _normalizeClass('room__button' + (index + 1))
                                          }, [
                                            _createElementVNode("span", null, "$ " + _toDisplayString(room.amount), 1),
                                            _createTextVNode(" " + _toDisplayString(room.roomName), 1)
                                          ], 2),
                                          _createElementVNode("div", _hoisted_20, [
                                            _createVNode(_component_el_row, {
                                              guter: 24,
                                              class: "room__details"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_21,
                                                    _createElementVNode("p", _hoisted_22, _toDisplayString(room.roomType), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_el_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_23,
                                                    _createElementVNode("p", _hoisted_24, " x" + _toDisplayString(room.roomCapacityAdults), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_el_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_25,
                                                    _createElementVNode("p", _hoisted_26, " x" + _toDisplayString(room.roomCapacitychildren), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}